// Well, this is not the correct way
// Just note that this should be a theme used by all code rather than hard code.
export const theme = {
  enableTextColor: '#0078d4',
  enableTextHoverColor: '#004578',
  hoverBackgroundColor: '#EDEBE9',
};
